import { Serializable } from '@admin/core/models/serializable';

export class CustomerAgentSaveResultModel
  implements Serializable<CustomerAgentSaveResultModel>
{
  fromObject(obj: any): CustomerAgentSaveResultModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public error: string;
  public errorCode: number;
}
